(function () {
  "use strict";

  if (window.__squadReviewMarqueeInstalled) return;
  window.__squadReviewMarqueeInstalled = true;

  function cleanText(value) {
    return (value || "").replace(/\s+/g, " ").trim();
  }

  function readText(source, selector) {
    var element = source.querySelector(selector);
    return element ? cleanText(element.textContent) : "";
  }

  function makeElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (typeof text === "string") element.textContent = text;
    return element;
  }

  function reviewScore(source) {
    var score = source.querySelectorAll(".jdgm-star.jdgm--on").length;
    if (!score) {
      var scored = source.querySelector("[data-score]");
      score = scored ? Math.round(parseFloat(scored.getAttribute("data-score")) || 0) : 0;
    }
    return Math.max(1, Math.min(5, score || 5));
  }

  function buildCard(source) {
    var name = readText(source, ".jdgm-carousel-item__reviewer-name") || "Customer";
    var date = readText(source, ".jdgm-carousel-item__timestamp");
    var body = readText(source, ".jdgm-carousel-item__review-body");
    var imageSource = source.querySelector(".jdgm-carousel-item__image-wrapper img, img");
    var imageUrl = "";

    if (imageSource) {
      imageUrl =
        imageSource.getAttribute("data-src") ||
        imageSource.getAttribute("data-lazy-src") ||
        imageSource.currentSrc ||
        imageSource.getAttribute("src") ||
        "";
    }

    var card = makeElement("article", "squad-review-card");
    if (!imageUrl) card.classList.add("squad-review-card--no-image");

    var header = makeElement("div", "squad-review-card__header");
    var avatar = makeElement("span", "squad-review-card__avatar", name.charAt(0));
    avatar.setAttribute("aria-hidden", "true");

    var identity = makeElement("div", "squad-review-card__identity");
    var nameLine = makeElement("div", "squad-review-card__name-line");
    var nameElement = makeElement("span", "squad-review-card__name", name);
    var verified = makeElement("span", "squad-review-card__verified", "✓");
    verified.setAttribute("title", "Verified review");
    verified.setAttribute("aria-label", "Verified review");

    nameLine.appendChild(nameElement);
    nameLine.appendChild(verified);
    identity.appendChild(nameLine);

    if (date) {
      identity.appendChild(makeElement("span", "squad-review-card__date", date));
    }

    header.appendChild(avatar);
    header.appendChild(identity);
    card.appendChild(header);

    var score = reviewScore(source);
    var stars = makeElement("div", "squad-review-card__stars");
    stars.setAttribute("aria-label", score + " out of 5 stars");

    for (var i = 1; i <= 5; i += 1) {
      stars.appendChild(
        makeElement(
          "span",
          i <= score ? "squad-review-card__star" : "squad-review-card__star squad-review-card__star--off",
          "★"
        )
      );
    }

    card.appendChild(stars);

    var content = makeElement("div", "squad-review-card__content");
    content.appendChild(makeElement("p", "squad-review-card__text", body));

    if (imageUrl) {
      var image = makeElement("img", "squad-review-card__image");
      image.alt = "";
      image.loading = "lazy";
      image.decoding = "async";
      image.addEventListener("error", function () {
        card.classList.add("squad-review-card--no-image");
        if (image.parentNode) image.parentNode.removeChild(image);
      }, { once: true });
      content.appendChild(image);
      image.src = imageUrl;
      window.setTimeout(function () {
        if (image.complete && !image.naturalWidth) {
          card.classList.add("squad-review-card--no-image");
          if (image.parentNode) image.parentNode.removeChild(image);
        }
      }, 2500);
    }

    card.appendChild(content);
    return card;
  }

  function buildGroup(sources, hidden) {
    var group = makeElement("div", "squad-review-group");
    if (hidden) group.setAttribute("aria-hidden", "true");

    sources.forEach(function (source) {
      group.appendChild(buildCard(source));
    });

    return group;
  }

  function buildRow(sources, reverse) {
    var row = makeElement("div", "squad-review-row");
    var track = makeElement(
      "div",
      reverse ? "squad-review-track squad-review-track--reverse" : "squad-review-track"
    );

    track.appendChild(buildGroup(sources, false));
    track.appendChild(buildGroup(sources, true));
    row.appendChild(track);
    return row;
  }

  function mount() {
    var wrapper = document.querySelector(".jdgm-carousel-wrapper");
    if (!wrapper || wrapper.classList.contains("squad-review-ready")) return false;

    var original = wrapper.querySelector(".jdgm-carousel");
    var items = Array.prototype.slice.call(
      wrapper.querySelectorAll(".jdgm-carousel__item-wrapper .jdgm-carousel-item")
    );

    if (!original || items.length < 4) return false;

    var rowOne = items.filter(function (_item, index) { return index % 2 === 0; });
    var rowTwo = items.filter(function (_item, index) { return index % 2 === 1; });

    if (rowTwo.length < 2) return false;

    var marquee = makeElement("div", "squad-review-marquee");
    marquee.setAttribute("role", "region");
    marquee.setAttribute("aria-label", "Customer reviews");
    marquee.appendChild(buildRow(rowOne, false));
    marquee.appendChild(buildRow(rowTwo, true));

    original.insertAdjacentElement("afterend", marquee);
    wrapper.classList.add("squad-review-ready");
    return true;
  }

  function begin() {
    if (mount()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (mount() || attempts >= 60) window.clearInterval(timer);
    }, 350);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", begin, { once: true });
  } else {
    begin();
  }
})();